import type { Guide, GuideRecordHint } from '../types';

/** S-20.10-13 — rejestr ofert przewoźników (scenariusz e2e 12, ścieżka TRD-06). */
const TRADE_ORDER: GuideRecordHint = {
  description: 'zlecenie w Trade',
  listPath: '/user-offers',
  listFilter: { forklift: 'hide', dzial: 'TRADE' },
};

export const guide: Guide = {
  flagKey: 'carrierOfferRegister',
  title: 'Rejestr ofert przewoźników',
  whatItDoes:
    'Na karcie zlecenia w Trade sekcja „Oferty przewoźników”: trader zapisuje ofertę przewoźnika albo swoją kontrofertę z telefonu, maila albo giełdy — przewoźnik z kartoteki, kwota, waluta, termin ważności, źródło i uwagi. Przy każdej ofercie marża wobec ceny zlecenia. Nic nie wychodzi na zewnątrz i nic nie zmienia stanu zlecenia; wpisy idą do historii, a na liście jest filtr „Z ofertami przewoźników”.',
  audience: ['Trade'],
  presentationItems: ['S-20.10-13'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: TRADE_ORDER,
      target: 'carrier-offers',
      mockupTestId: 'trd-negocjacja-kontroferta',
      title: 'Sekcja „Oferty przewoźników”',
      description:
        'Zapisane oferty i kontroferty z marżą przy każdej (kurs NBP z dnia załadunku). Ofertę można odrzucić z powodem.',
      action: 'Otwórz zlecenie w Trade i przejdź do sekcji „Oferty przewoźników”.',
      recorder: { account: 'trade', demo: { kind: 'order', number: 'DEMO/2026/10/T02' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: TRADE_ORDER,
      target: 'carrier-offer-form',
      title: 'Nowa oferta',
      description:
        'Formularz: przewoźnik z kartoteki, rodzaj (oferta przewoźnika albo kontroferta), kwota, waluta, ważność, źródło i uwagi.',
      action: 'Wybierz przewoźnika, rodzaj i kwotę, potem „Zapisz ofertę”.',
      recorder: { account: 'trade', demo: { kind: 'order', number: 'DEMO/2026/10/T02' } },
    },
  ],
};
